$(function () {
    'use strict';

    Vue.use(VeeValidate);

    var signupVue = new Vue({

        el: '#signupPanel',

        data: {
            email: null,
            nickname: null,
            firstName: null,
            lastName: null,
            password: null,
            passwordConfirm: null,
            terms: false,
            dob: null,
            trainingAge: 'LEVEL_1',
            authorization: 'NOT_IMPLEMENTED',
            dobInstance: null,
            createSuccess: false,
        },

        methods: {

            verifyNickname: function () {
                this.$validator.validate('nickname', this.nickname);
            },

            verifyAuthorization: function () {
                this.$validator.validate('authorization', this.authorization);
            },

            verifyEmail: function () {
                this.$validator.validate('email', this.email);
            },

            processSignup: function () {

                var _me = this;

                var data = {
                    email: this.email,
                    nickname: this.nickname,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    password: this.password,
                    authorization: this.authorization,
                    dob: this.dob,
                    trainingAge: this.trainingAge,
                };

                this.$validator.validateAll(data)
                    .then(function (result) {

                        if (result) {

                            return _me.$http.post('/api/user', data)
                                .then(function (response) {
                                    _me.createSuccess = response.data;
                                    if (_me.createSuccess) {
                                        if (__returnToUrl && __returnToUrl !== '') {
                                            window.location.href = __returnToUrl;
                                        } else {
                                            window.location.href = '/workout';
                                        }
                                    }

                                });

                        } else {
                            //validation failed....
                        }

                    });

            }

        },

        mounted: function () {

            var _me = this;

            var earliestDateOfBirth = new Date();
            earliestDateOfBirth.setDate(earliestDateOfBirth.getDate() - 4758);
            this.dobInstance = mobiscroll.date('#dob', {
                max: earliestDateOfBirth,
                theme: 'bootstrap',
                onSet: function (event, inst) {
                    _me.dob = inst.getVal().toISOString().slice(0, 10);
                }
            });

        },

        created: function () {

            var _me = this;

            /**
             * Custom validators to determine whether or not this user can register
             */
            VeeValidate.Validator.extend('verify_nickname_unique', {
                getMessage: function (field) {
                    return 'The Profile Handle ' + field + ' is already taken';
                },
                validate: function (value) {
                    return _me.$http.get('/api/user/nickname/exists/' + value)
                        .then(function (result) {
                            return {valid: !result.data};
                        });
                }
            });

            this.$validator.attach('nickname', 'required|alpha_dash|verify_nickname_unique', {alias: 'Profile Handle'});

            // VeeValidate.Validator.extend('verify_authorization_available', {
            //     getMessage: function (field) {
            //         return 'The Beta Invite Code ' + field + ' has already been used';
            //     },
            //     validate: function (value) {
            //         return _me.$http.get('/api/authorization/beta/' + value)
            //             .then(function (result) {
            //                 return {valid: result.data};
            //             });
            //     }
            // });
            //
            // this.$validator.attach('authorization', 'required|alpha_num|verify_authorization_available', {alias: 'Beta Invite Code'});

            VeeValidate.Validator.extend('verify_email_unique', {
                getMessage: function (field) {
                    return 'The Email Address ' + field + ' is already in use';
                },
                validate: function (value) {
                    return _me.$http.get('/api/user/email/exists/' + value)
                        .then(function (result) {
                            return {valid: !result.data};
                        });
                }
            });

            this.$validator.attach('email', 'required|email|verify_email_unique', {alias: 'Email Address'});

        }

    });

});